import styled from "styled-components";
export const Wrapper = styled.span `
  display: block;
  line-height: 0;
  ${({ withHitSpace }) => withHitSpace
    ? `width: 2.5rem;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;`
    : ""}

  @media ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.device) === null || _a === void 0 ? void 0 : _a.touch; }} {
    ${({ withHitSpace }) => withHitSpace ? `height: 2.75rem; width: 2.75rem;` : ""}
  }

  svg {
    width: ${({ width }) => width};
    ${({ color }) => (color ? `fill: ${color}` : "")};
    path {
      ${({ color }) => (color ? `fill: ${color}` : "")};
    }
  }
`;
